import React, { Component } from "react";
import FooterHome from "./FooterHome";
import { StickyOrgNavbar } from "../OrgNavbar";

export const ROUTE_LOAD_NOTICE_DELAY_MS = 10000;

function RouteLoadShell({ children, role }) {
  return (
    <div className="flex min-h-screen flex-col">
      <StickyOrgNavbar />
      {children}
      <FooterHome />
    </div>
  );
}

export function RouteLoadingFallback() {
  const [takingLonger, setTakingLonger] = React.useState(false);

  React.useEffect(() => {
    const timeoutId = window.setTimeout(
      () => setTakingLonger(true),
      ROUTE_LOAD_NOTICE_DELAY_MS
    );
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <RouteLoadShell role="status">
      <div role="status" className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
        {takingLonger && <button type="button" onClick={() => window.location.reload()}>Retry</button>}
      </div>
    </RouteLoadShell>
  );
}

export class RouteLoadBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error("Unable to load application route.", error);
  }

  render() {
    if (this.state.error) {
      return (
        <RouteLoadShell role="alert">
          <div role="alert" className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
            <p>We could not load this page.</p>
            <button type="button" onClick={() => window.location.reload()}>Reload page</button>
          </div>
        </RouteLoadShell>
      );
    }

    return this.props.children;
  }
}
